// Code goes here

const list = [
    "#HotorNot",
    "#RateMe",
    "$h1t",
    ":A n :A :L",
    ":B a :S :T a :R Big Grin",
    ":B i :T :C :H",
    ":C u :M",
    ":F a :G :G :O t",
    ":F u :C :K",
    ":H e :N :T a :I",
    ":R a Tongue :E",
    ":S e :M :E :N",
    ":S e :X",
    ":S h :I :T",
    "@$$",
    "2 girls 1 cup",
    "2g1c",
    "4r5e",
    "5h1t",
    "5hit",
    "a_s_s",
    "a55hole",
    "abbo",
    "abo",
    "acrotomophilia",
    "aeolus",
    "africoon",
    "ag jou hol man",
    "ahole",
    "alabama hot pocket",
    "alaskan pipeline",
    "alligator bait",
    "Alligator bait ",
    "alligatorbait",
    "analprobe",
    "analsex",
    "anilingus",
    "arabush",
    "Arabush ",
    "arabushs",
    "areola",
    "areole",
    "armos",
    "Arsed",
    "arsehole",
    "ass bag",
    "ass bandit",
    "ass banger",
    "ass bite",
    "ass clown",
    "ass cock",
    "ass cracker",
    "ass face",
    "ass fuck",
    "ass fuck   ",
    "ass goblin",
    "ass head",
    "ass hole",
    "ass hopper",
    "ass jacker",
    "ass lick",
    "ass licker",
    "ass monkey",
    "ass muncher",
    "ass nigger",
    "ass shit",
    "ass sucker",
    "assbag",
    "assbagger",
    "assbandit",
    "assbang",
    "assbanged",
    "assbanger",
    "assbangs",
    "assbite",
    "assblaster",
    "assclown",
    "asscock",
    "asscowboy",
    "asscracker",
    "ass bag",
    "ass bagger",
    "assbandit",
    "ass bang",
    "ass banged",
    "ass banger",
    "ass bangs",
    "ass bite",
    "ass blaster",
    "ass clown",
    "ass cock",
    "ass cowboy",
    "ass cracker",
    "assface",
    "assfaces",
    "assfuck",
    "assfucker",
    "ass face",
    "ass faces",
    "assfuck",
    "ass fucker",
    "ass-fucker",
    "assfukka",
    "assgoblin",
    "assh0le",
    "asshat",
    "ass face",
    "ass faces",
    "ass fuck",
    "ass fucker",
    "ass face",
    "ass faces",
    "ass fuck",
    "ass fucker",
    "ass-fucker",
    "ass fukka",
    "ass goblin",
    "ass h0le",
    "ass hat",
    "ass-hat",
    "asshead",
    "assho1e",
    "asshole",
    "assholes",
    "asshopper",
    "asshore",
    "ass head",
    "ass ho1e",
    "ass hole",
    "ass holes",
    "ass hopper",
    "ass hore",
    "ass-jabber",
    "assjacker",
    "assjockey",
    "asskiss",
    "asskisser",
    "assklown",
    "asslick",
    "asslicker",
    "asslover",
    "assman",
    "assmaster",
    "assmonkey",
    "assmucus   ",
    "assmunch",
    "assmuncher",
    "assnigger",
    "asspacker",
    "asspirate",
    "ass jacker",
    "ass jockey",
    "ass kiss",
    "ass kisser",
    "ass klown",
    "ass lick",
    "ass licker",
    "ass lover",
    "ass man",
    "ass master",
    "ass monkey",
    "ass mucus   ",
    "ass munch",
    "ass muncher",
    "ass nigger",
    "ass packer",
    "ass pirate",
    "ass-pirate",
    "asspuppies",
    "assranger",
    "assshit",
    "assshole",
    "asssucker",
    "asswad",
    "asswhole",
    "asswhore",
    "asswipe",
    "asswipes",
    "ass puppies",
    "ass ranger",
    "ass shit",
    "asss hole",
    "ass sucker",
    "ass wad",
    "ass whole",
    "ass whore",
    "ass wipe",
    "ass wipes",
    "auto erotic",
    "autoerotic",
    "axwound",
    "azazel",
    "azz",
    "b!tch",
    "b00bs",
    "b17ch",
    "b1tch",
    "babeland",
    "baby batter",
    "baby juice",
    "badfuck",
    "Balija ",
    "ball gag",
    "ball gravy",
    "ball licking",
    "ball sucking",
    "ballbag",
    "balllicker",
    "Bamboula",
    "bampot",
    "ball bag",
    "ball licker",
    "Bam boula",
    "bam pot",
    "bang (one's) box   ",
    "bangbros",
    "bareback",
    "bang bros",
    "bare back",
    "barely legal",
    "barelylegal",
    "barenaked",
    "barface",
    "barfface",
    "bare naked",
    "bar face",
    "barf face",
    "bast",
    "batty boy",
    "bawdy",
    "bazongas",
    "bazooms",
    "bbw",
    "bdsm",
    "beaner",
    "beaners",
    "beardedclam",
    "bearded clam",
    "beastality",
    "beastial",
    "beastiality",
    "beatch",
    "beatoff",
    "beatyourmeat",
    "beat off",
    "beat your meat",
    "beaver",
    "beaver cleaver",
    "beaver lips",
    "beef curtain   ",
    "beef curtains",
    "beeyotch",
    "bellend",
    "bender",
    "Béni-oui-oui",
    "beotch",
    "bescumber",
    "bestial",
    "bestiality",
    "bi+ch",
    "Bible basher ",
    "Bible beater ",
    "Bible thumper ",
    "bicurious",
    "big black",
    "big breasts",
    "Big Grin i :C :K",
    "big knockers",
    "big tits",
    "bigass",
    "bigbastard",
    "bigbutt",
    "bigtits",
    "big ass",
    "big bastard",
    "big butt",
    "bigtits",
    "bint",
    "birdlock",
    "bisexual",
    "bitch",
    "bitch tit   ",
    "bitchass",
    "bitcher",
    "bitchers",
    "bitches",
    "bitchez",
    "bitchin",
    "bitching",
    "bitchslap",
    "bitchtits",
    "bitchy",
    "biteme",
    "black cock",
    "blerrie",
    "blonde action",
    "blonde on blonde action",
    "bloodclaat",
    "blow job",
    "blow me   ",
    "blow mud   ",
    "blow your load",
    "blowjob",
    "blowjobs",
    "blue waffle",
    "blue waffle   ",
    "blow jobs",
    "blumpkin",
    "blumpkin   ",
    "boang",
    "boche",
    "boches",
    "bodily",
    "Boer hater",
    "Boerehater",
    "Boer-hater",
    "Bog Irish",
    "bogan",
    "Bogtrotter",
    "Bog-trotter",
    "Bog trotter",
    "bohunk",
    "boink",
    "boiolas",
    "bollick",
    "bollox",
    "bomb",
    "bombers",
    "bombing",
    "bombs",
    "bomd",
    "bondage",
    "boned",
    "boner",
    "boners",
    "bong",
    "boob",
    "boobies",
    "boobs",
    "booby",
    "boody",
    "booger",
    "bookie",
    "boom",
    "boong",
    "boong ",
    "boonga",
    "boongas",
    "boongs",
    "boonie",
    "boonies",
    "booobs",
    "boooobs",
    "booooobs",
    "booooooobs",
    "bootee",
    "bootie",
    "bootlip",
    "bootlips",
    "booty",
    "booty call",
    "bootycall",
    "boud kapper",
    "boudkapper",
    "Bougnoule",
    "bounty bar",
    "bounty bars",
    "bountybar",
    "Bozgor",
    "brea5t",
    "breast",
    "breastjob",
    "breastlover",
    "breastman",
    "breast job",
    "breast lover",
    "breas tman",
    "breasts",
    "Breeder",
    "brothel",
    "brother fucker",
    "brotherfucker",
    "brown showers",
    "brunette action",
    "buceta",
    "buddhahead",
    "buddhaheads",
    "Buffie",
    "buffies",
    "buffy",
    "buggered",
    "buggery",
    "bukkake",
    "bule",
    "bules",
    "bull shit",
    "bullcrap",
    "bulldike",
    "bulldyke",
    "bull crap",
    "bull dike",
    "bull dyke",
    "bullet vibe",
    "bullshit",
    "bullshits",
    "bullshitted",
    "bullturds",
    "bull shits",
    "bull shitted",
    "bull turds",
    "bum boy",
    "bumble fuck",
    "bumblefuck",
    "bumclat",
    "bumfuck",
    "bum clat",
    "bum fuck",
    "buncombe",
    "bung hole",
    "bunghole",
    "bunny fucker",
    "burr head",
    "burr heads",
    "burrhead",
    "Burr-head",
    "burrheads",
    "bust a load   ",
    "butchbabes",
    "butchdike",
    "butchdyke",
    "butch babes",
    "butch dike",
    "butch dyke",
    "butt fuck",
    "butt fuck   ",
    "butt plug",
    "buttbang",
    "buttcheeks",
    "buttface",
    "buttfuck",
    "buttfucka",
    "buttfucker",
    "buttfuckers",
    "butthead",
    "butthole",
    "buttman",
    "buttmuch",
    "buttmunch",
    "buttmuncher",
    "buttpirate",
    "butt bang",
    "butt cheeks",
    "butt face",
    "butt fuck",
    "butt fucka",
    "butt fucker",
    "butt fuckers",
    "butt head",
    "butt hole",
    "butt man",
    "butt much",
    "butt munch",
    "butt muncher",
    "butt pirate",
    "butt-pirate",
    "buttplug",
    "buttstain",
    "butt plug",
    "butt stain",
    "byatch",
    "c*t m*s*lf",
    "c.0.c.k",
    "c.o.c.k.",
    "c.u.n.t",
    "c0ck",
    "c-0-c-k",
    "c0cksucker",
    "Cabbage Eater",
    "caca",
    "cacafuego",
    "cahone",
    "camel jockey",
    "camel jockeys",
    "camel toe",
    "cameljockey",
    "cameltoe",
    "camgirl",
    "camslut",
    "camwhore",
    "cameljockeys",
    "camel toe",
    "cam girl",
    "cam slut",
    "camwhore",
    "carpet muncher",
    "carpetmuncher",
    "carruth",
    "cawk",
    "Chankoro",
    "chav",
    "cheese eating surrender monkey",
    "cheese eating surrender monkies",
    "cheeseeating surrender monkey",
    "cheeseeating surrender monkies",
    "cheesehead",
    "cheeseheads",
    "cheese head",
    "cheese heads",
    "Chernozhopy",
    "cherrypopper",
    "chesticle",
    "chi-chi man",
    "chick with a dick",
    "chickslick",
    "chick slick",
    "child-fucker",
    "Chilote",
    "china swede",
    "china swedes",
    "chinaswedes",
    "chinc",
    "chincs",
    "ching chong",
    "ching chongs",
    "chingchong",
    "chingchongs",
    "chink",
    "chinks",
    "chinky",
    "choad",
    "choade   ",
    "chocolate rosebuds",
    "chode",
    "chodes",
    "Cholo",
    "chonkies",
    "chonky",
    "chonkys",
    "chota bags   ",
    "christ killer",
    "christ killers",
    "Christ on a bike",
    "Christ on a cracker",
    "chug",
    "chugs",
    "chunger",
    "chungers",
    "Churka ",
    "ciapak",
    "Ciapaty",
    "Cina",
    "cipa",
    "circlejerk",
    "cl1t",
    "Clamhead",
    "cleveland steamer",
    "clit",
    "clit licker   ",
    "clitface",
    "clitfuck",
    "clit face",
    "clit fuck",
    "clitoris",
    "clitorus",
    "clits",
    "clitty",
    "clitty litter   ",
    "clogwog",
    "clog wog",
    "clover clamps",
    "clunge",
    "clusterfuck",
    "cluster fuck",
    "cnut",
    "cocain",
    "cocaine",
    "coccydynia",
    "cock",
    "c-o-c-k",
    "cock ass",
    "cock bite",
    "cock burger",
    "cock fucker",
    "cock jockey",
    "cock knoker",
    "cock master",
    "cock mongler",
    "cock mongruel",
    "cock monkey",
    "cock nose",
    "cock nugget",
    "cock pocket   ",
    "cock shit",
    "cock smith",
    "cock smoke",
    "cock smoker",
    "cock sniffer",
    "cock snot   ",
    "cock sucker",
    "cock waffle",
    "cockass",
    "cockbite",
    "cockblock",
    "cockblocker",
    "cockburger",
    "cockcowboy",
    "cockface",
    "cockfucker",
    "cockhead",
    "cockholster",
    "cockjockey",
    "cockknob",
    "cockknocker",
    "cockknoker",
    "cocklicker",
    "cocklover",
    "Cocklump",
    "cockmaster",
    "cockmongler",
    "cockmongruel",
    "cockmonkey",
    "cockmunch",
    "cockmuncher",
    "cocknob",
    "cocknose",
    "cocknugget",
    "cockqueen",
    "cockrider",
    "cock ass",
    "cock bite",
    "cock block",
    "cock blocker",
    "cock burger",
    "cock cowboy",
    "cock face",
    "cock fucker",
    "cock head",
    "cock holster",
    "cock jockey",
    "cock knob",
    "cock knocker",
    "cock knoker",
    "cock licker",
    "cock lover",
    "Cock lump",
    "cock master",
    "cock mongler",
    "cock mongruel",
    "cock monkey",
    "cock munch",
    "cock muncher",
    "cock nob",
    "cock nose",
    "cock nugget",
    "cock queen",
    "cock rider",
    "cocks",
    "cockshit",
    "cocksman",
    "cocksmith",
    "cocksmoke",
    "cocksmoker",
    "cocksniffer",
    "cocksucer",
    "cocksuck",
    "cocksuck ",
    "cocksucked",
    "cocksucked ",
    "cocksucker",
    "cock-sucker",
    "cocksuckers",
    "cocksucking",
    "cocksucks",
    "cocksucks ",
    "cocksuka",
    "cocksukka",
    "cockwaffle",
    "Cockwomble",
    "cock shit",
    "cock sman",
    "cock smith",
    "cock smoke",
    "cock smoker",
    "cock sniffer",
    "cock sucer",
    "cock suck",
    "cock suck ",
    "cock sucked",
    "cock sucked ",
    "cock sucker",
    "cock-sucker",
    "cock suckers",
    "cock sucking",
    "cock sucks",
    "cock sucks ",
    "cock suka",
    "cock sukka",
    "cock waffle",
    "Cock womble",
    "coffin dodger",
    "cohee",
    "coital",
    "coitus",
    "cok",
    "Cokin",
    "cokmuncher",
    "coksucka",
    "cok muncher",
    "cok sucka",
    "coochie",
    "coochy",
    "coolie",
    "coolies",
    "cooly",
    "coon",
    "coon ass",
    "coon asses",
    "Coon hunting",
    "coonass",
    "Coon-ass",
    "coonasses",
    "coondog",
    "coon dog",
    "coonnass",
    "coons",
    "cooter",
    "cop some wood   ",
    "coprolagnia",
    "coprophilia",
    "copulate",
    "corksucker",
    "cornhole",
    "cork sucker",
    "corn hole",
    "corp whore   ",
    "corpulent",
    "corruption",
    "cra5h",
    "cracka",
    "crackpipe",
    "crackwhore",
    "crack pipe",
    "crack whore",
    "creampie",
    "Creeping Jesus ",
    "crotchjockey",
    "crotchmonkey",
    "crotchrot",
    "crotte",
    "cum",
    "cum chugger   ",
    "cum dumpster   ",
    "cum freak   ",
    "cum guzzler   ",
    "cum jockey",
    "cum slut",
    "cum tart",
    "cumbubble",
    "cumdump   ",
    "cumdumpster",
    "cumfest",
    "cumguzzler",
    "cumjockey",
    "cumm",
    "cummer",
    "cummin",
    "cumming",
    "cumquat",
    "cumqueen",
    "cums",
    "cumshot",
    "cumshots",
    "cumslut",
    "cumstain",
    "cumtart",
    "cum shot",
    "cum shots",
    "cum slut",
    "cum stain",
    "cum tart",
    "cunilingus",
    "cunillingus",
    "cunn",
    "cunnie",
    "cunnilingus",
    "cunntt",
    "cunny",
    "cunt",
    "c-u-n-t",
    "cunt face",
    "cunt hair   ",
    "cunt hole",
    "cunt rag",
    "cunt slut",
    "cuntass",
    "cuntbag   ",
    "cunteyed",
    "cuntface",
    "cuntfuck",
    "cuntfucker",
    "cunthole",
    "cunthunter",
    "cuntlick",
    "cuntlick ",
    "cuntlicker",
    "cuntlicker ",
    "cuntlicking",
    "cuntlicking ",
    "cuntrag",
    "cunt bag   ",
    "cunt eyed",
    "cunt face",
    "cunt fuck",
    "cunt fucker",
    "cunt hole",
    "cunt hunter",
    "cunt lick",
    "cunt lick ",
    "cunt licker",
    "cunt licker ",
    "cunt licking",
    "cunt licking ",
    "cuntrag",
    "cunts",
    "cuntsicle   ",
    "cuntslut",
    "cunt-struck   ",
    "cuntsucker",
    "cunt sicle   ",
    "cunt slut",
    "cunt-struck   ",
    "cunt sucker",
    "curry muncher",
    "curry munchers",
    "currymuncher",
    "Curry-muncher",
    "currymunchers",
    "cus",
    "cushi",
    "cushis",
    "cut rope   ",
    "cyalis",
    "cyber fuc",
    "cyber fuck",
    "cyber fucked",
    "cyber fucker",
    "cyber fuckers",
    "cyber fucking",
    "cyberfuc",
    "cyberfuck",
    "cyberfuck ",
    "cyberfucked",
    "cyberfucked ",
    "cyberfucker",
    "cyberfuckers",
    "cyberfucking",
    "cyberfucking ",
    "cybersex",
    "cyberslimer",
    "d0ng",
    "d0uch3",
    "d0uche",
    "d1ck",
    "d1ld0",
    "d1ldo",
    "dago",
    "dagos",
    "dahmer",
    "Dal Khor",
    "darkey",
    "darkeys",
    "darkie",
    "darkies",
    "darky",
    "date rape",
    "daterape",
    "datnigga",
    "dawgie-style",
    "deapthroat",
    "deep throat",
    "deepthroat",
    "deap throat",
    "defecate",
    "deggo",
    "dego",
    "degos",
    "dendrophilia",
    "devilworshipper",
    "diaper head",
    "diaper heads",
    "diaperhead",
    "diaperheads",
    "dick",
    "dick bag",
    "dick beaters",
    "dick face",
    "dick fuck",
    "dick fucker",
    "dick head",
    "dick hole",
    "dick hole   ",
    "dick juice",
    "dick milk ",
    "dick monger",
    "dick shy   ",
    "dickbag",
    "dickbeaters",
    "dickbrain",
    "dickdipper",
    "dickface",
    "dickflipper",
    "dickforbrains",
    "dickfuck",
    "dickfucker",
    "dickhead",
    "dickheads",
    "dickhole",
    "dickish",
    "dick heads",
    "dick hole",
    "dick ish",
    "dick-ish",
    "dickjuice",
    "dickless",
    "dicklick",
    "dicklicker",
    "dickman",
    "dickmilk ",
    "dickmonger",
    "dickripper",
    "dick juice",
    "dick less",
    "dick lick",
    "dick licker",
    "dick man",
    "dick milk ",
    "dick monger",
    "dickripper",
    "dicks",
    "dicksipper",
    "dickslap",
    "dick-sneeze",
    "dicksucker",
    "dicksucking",
    "dicktickler",
    "dickwad",
    "dickweasel",
    "dickweed",
    "dickwhipper",
    "dickwod",
    "dickzipper",
    "dick sipper",
    "dick slap",
    "dick sneeze",
    "dick sucker",
    "dick sucking",
    "dick tickler",
    "dick wad",
    "dick weasel",
    "dick weed",
    "dick whipper",
    "dick wod",
    "dick zipper",
    "dicksneeze",
    "diddle",
    "dik",
    "dike",
    "dildo",
    "dildos",
    "diligaf",
    "dillweed",
    "dingle",
    "dingleberries",
    "dingleberry",
    "dingle berries",
    "dingle berry",
    "dink",
    "dinks",
    "dipship",
    "dipshit",
    "dipstick",
    "dip ship",
    "dip shit",
    "dip stick",
    "dirsa",
    "dirty pillows",
    "dirtypillows",
    "dirty Sanchez   ",
    "dix",
    "dixiedike",
    "dlck",
    "dog style",
    "Dogan",
    "dog-fucker",
    "doggie style",
    "doggiestyle",
    "doggie-style",
    "doggin",
    "dogging",
    "doggy style",
    "doggystyle",
    "doggy-style",
    "dogun",
    "dolcett",
    "dominatrix",
    "dommes",
    "dong",
    "donkey punch",
    "donkey ribber",
    "donkeypunch",
    "donkeyribber",
    "Donkie kont",
    "doochbag",
    "doodoo",
    "doofus",
    "dookie",
    "Doos",
    "doosh",
    "Doosis",
    "dot head",
    "dot heads",
    "dothead",
    "dotheads",
    "double dong",
    "double penetration",
    "Doublelift",
    "douch3",
    "douche",
    "douche-fag",
    "douchewaffle",
    "douchey",
    "dp action",
    "draad trekker",
    "Draadtrekker",
    "dripdick",
    "drip dick",
    "Druggies",
    "dry hump",
    "duche",
    "dumbbitch",
    "Dumbcunt",
    "dumbfuck",
    "dumb bitch",
    "Dumb cunt",
    "dumb fuck",
    "dune coon",
    "dune coons",
    "dvda",
    "dyefly",
    "dyke",
    "dykes",
    "easyslut",
    "easyslut",
    "eat a dick   ",
    "eat hair pie   ",
    "eat my ass",
    "eatballs",
    "eatme",
    "eatpussy",
    "EATSHiT",
    "eat balls",
    "eat me",
    "eatpussy",
    "EAT SHiT",
    "ecchi",
    "ejaculate",
    "ejaculated",
    "ejaculates",
    "ejaculates ",
    "ejaculating",
    "ejaculating ",
    "ejaculatings",
    "ejaculation",
    "ejakulate",
    "ek gan jou klap men ñ nat piel",
    "Ek gee nie 'n fok nie",
    "Ek gee nie 'n moer om nie",
    "enema",
    "erect",
    "erection",
    "ero",
    "escort",
    "esqua",
    "essohbee",
    "Etterkop",
    "eunuch",
    "excrement",
    "executioner",
    "exkwew",
    "Eyetie",
    "f u c k",
    "f u c k e r",
    "f*ck",
    "f.u.c.k",
    "f_u_c_k",
    "f4nny",
    "facefucker",
    "face fucker",
    "facial   ",
    "fack",
    "faeces",
    "fag",
    "fagbag",
    "fagfucker",
    "fag bag",
    "fag fucker",
    "fagg",
    "fagged",
    "fagging",
    "faggit",
    "faggitt",
    "faggot",
    "faggotcock",
    "faggot cock",
    "faggots",
    "faggs",
    "fagot",
    "fagots",
    "fags",
    "fagtard",
    "faig",
    "faigt",
    "fanny flaps",
    "fanny fucker",
    "fannybandit",
    "fannyflaps",
    "fanny bandit",
    "fanny flaps",
    "fannyfucker",
    "fanyy",
    "farted",
    "farting",
    "fartknocker",
    "fart knocker",
    "farty",
    "fastfuck",
    "fast fuck",
    "fatah",
    "fatfuck",
    "fatfucker",
    "fatso",
    "fckcum",
    "fcuk",
    "fcuker",
    "fcuking",
    "fecal",
    "feces",
    "feck",
    "fecker",
    "feist",
    "felatio",
    "felch",
    "felcher",
    "felching",
    "fellate",
    "fellatio",
    "feltch",
    "feltcher",
    "feltching",
    "female squirting",
    "femdom",
    "fenian",
    "Fenian ",
    "fetish",
    "Feuj",
    "fice",
    "figging",
    "finger fucked",
    "finger fucker",
    "finger fuckers",
    "finger fucking",
    "finger fucks",
    "fingerbang",
    "fingerfuck",
    "fingerfuck ",
    "fingerfucked",
    "fingerfucked ",
    "fingerfucker",
    "fingerfucker ",
    "fingerfuckers",
    "finger fuck",
    "finger fucks",
    "fingerfucks",
    "fingerfucks ",
    "fingering",
    "fist fuck",
    "fist fuck   ",
    "fist fucked",
    "fist fucker",
    "fist fuckers",
    "fist fucking",
    "fist fuckings",
    "fist fucks",
    "fisted",
    "fister",
    "fistfuck",
    "fistfucked",
    "fistfucked ",
    "fistfucker",
    "fistfucker ",
    "fistfuckers",
    "fistfuckers ",
    "fistfucking",
    "fistfucking ",
    "fistfuckings",
    "flesh flute",
    "fistfucks",
    "fistfucks ",
    "fisting",
    "fisty",
    "flamer",
    "fleshflute",
    "flog the log   ",
    "floo",
    "floozy",
    "flydie",
    "flydye",
    "foad",
    "foah",
    "fok",
    "Fok die kak",
    "Fok jou",
    "Fok julle naaiers",
    "foken wil",
    "fokenwil",
    "Fokof",
    "fondle",
    "foobar",
    "fook",
    "fooker",
    "foot fetish",
    "footfuck",
    "footfucker",
    "footjob",
    "footlicker",
    "foreskin",
    "foot fuck",
    "foot fucker",
    "foot job",
    "foot licker",
    "fore skin",
    "forni",
    "fornicate",
    "foursome",
    "freakfuck",
    "freakyfucker",
    "freefuck",
    "four some",
    "freak fuck",
    "freaky fucker",
    "free fuck",
    "freex",
    "frenchify",
    "frigg",
    "frigga",
    "frotting",
    "fuc",
    "fucck",
    "fuck",
    "f-u-c-k",
    "fuck buttons",
    "fuck head",
    "fuck heads",
    "fuck hole   ",
    "fuck me",
    "Fuck off",
    "fuck puppet   ",
    "fuck trophy   ",
    "fuck whit",
    "fuck wit",
    "fuck yo mama   ",
    "fuck you",
    "fuckbuttons",
    "fuckhead",
    "fuckheads",
    "fuckhole   ",
    "fuckme",
    "Fuckoff",
    "fuckpuppet   ",
    "fucktrophy   ",
    "fuckwhit",
    "fuckwit",
    "fuck yo mama   ",
    "fuckyou",
    "fuck   ",
    "fucka",
    "fuckable",
    "fuckass",
    "fuck able",
    "fuck ass",
    "fuck-ass   ",
    "fuck bag",
    "fuckbag",
    "fuck-bitch   ",
    "fuckbook",
    "fuckboy",
    "fuckbrain",
    "fuckbuddy",
    "fuckbutt",
    "fuckbutter",
    "fuck book",
    "fuck boy",
    "fuck brain",
    "fuck buddy",
    "fuck butt",
    "fuck butter",
    "fucked",
    "fuckedup",
    "fucked up",
    "fucker",
    "fuckers",
    "fucked up",
    "fuckface",
    "fuckfest",
    "fuckfreak",
    "fuckfriend",
    "fuckhead",
    "fuckheads",
    "fuckher",
    "fuckhole",
    "fuck face",
    "fuck fest",
    "fuck freak",
    "fuck friend",
    "fuck head",
    "fuck heads",
    "fuck her",
    "fuck hole",
    "fuckin",
    "fuckina",
    "fucking",
    "fucking shit mother fucker",
    "fuckingbitch",
    "fucking bitch",
    "fuckings",
    "fuckingshitmotherfucker",
    "fuckinnuts",
    "fuckinright",
    "fuckit",
    "fuckknob",
    "fuckme",
    "fuckme ",
    "fuckmeat   ",
    "fuckmehard",
    "fuckmonkey",
    "fucknugget",
    "fucknut",
    "fucknutt",
    "fuckoff",
    "fuckpig",
    "fucking shit mother fucker",
    "fuckin nuts",
    "fuckin right",
    "fuck it",
    "fuckknob",
    "fuckme hard",
    "fuck me ",
    "fuck meat   ",
    "fuck me hard",
    "fuck monkey",
    "fuck nugget",
    "fuck nut",
    "fuck nutt",
    "fuck off",
    "fuck pig",
    "fucks",
    "fuckstick",
    "fucktard",
    "fuck stick",
    "fuck tard",
    "fuck-tard",
    "fucktards",
    "fucktart",
    "fucktoy   ",
    "fucktwat",
    "fuckup",
    "fuckwad",
    "fuckwhit",
    "fuckwhore",
    "fuckwit",
    "fuckwitt",
    "Fuckwittery",
    "fuckyou",
    "fuck tards",
    "fuck tart",
    "fuck toy   ",
    "fuck twat",
    "fuck up",
    "fuck wad",
    "fuck whit",
    "fuck whore",
    "fuck wit",
    "fuck witt",
    "Fuck wittery",
    "fuck you",
    "fudge packer",
    "fudgepacker",
    "fudge-packer",
    "fugly",
    "fuk",
    "fuk whit",
    "fuk wit",
    "fuker",
    "fukker",
    "fukkers",
    "fukkin",
    "fuks",
    "fukwhit",
    "fukwit",
    "funfuck",
    "fuk wit",
    "fun fuck",
    "fuq",
    "futanari",
    "fuuck",
    "fux",
    "fux0r",
    "fvck",
    "fxck",
    "gaan fok 'n bok",
    "gaan kak",
    "Gaan kak in die kaap",
    "Gaan kak in Gauteng",
    "Gaan kak in jou poes",
    "Gaan kak op jou ma se poes",
    "gaan klim terug in jou ma se poes",
    "Gaan naai jou hand",
    "Gaan naai jou Ma",
    "gaan naai 'n boom",
    "Gaan naai 'n koei",
    "Gaan Pluk jou riem",
    "Gaan vat 'n skommel",
    "gae",
    "gai",
    "Gaijin",
    "gang bang",
    "gang banged",
    "gangbang",
    "gang-bang   ",
    "gangbanged",
    "gangbanger",
    "gangbangs",
    "gang banged",
    "gang banger",
    "gang bangs",
    "ganja",
    "gassy ass   ",
    "Gat Gaabaa",
    "Gat gabba",
    "gator bait",
    "gatorbait",
    "gay lord",
    "gay sex",
    "gayass",
    "gaybob",
    "gaydo",
    "gayfuck",
    "gayfuckist",
    "gaylord",
    "gaymuthafuckinwhore",
    "gay ass",
    "gay bob",
    "gay do",
    "gay fuck",
    "gay fuckist",
    "gay lord",
    "gay mutha fuckin whore",
    "gays",
    "gaysex",
    "gaytard",
    "gaywad",
    "gay sex",
    "gay tard",
    "gay wad",
    "gender bender",
    "geni",
    "genital",
    "genitals",
    "getiton",
    "gfy",
    "ghay",
    "ghey",
    "giant cock",
    "gigolo",
    "Gin jockey",
    "ginzo",
    "ginzos",
    "gipp",
    "gippo",
    "gippos",
    "gipps",
    "girl on top",
    "girls gone wild",
    "give head",
    "givehead",
    "glans",
    "glazeddonut",
    "GO.FUCK.YOURSELF",
    "goatcx",
    "goatse",
    "God botherer",
    "god damn",
    "god damned",
    "godamn",
    "godamnit",
    "goddam",
    "god-dam",
    "goddammit",
    "goddamn",
    "goddamned",
    "god-damned",
    "goddamnit",
    "goddamnmuthafucker",
    "godsdamn",
    "gokkun",
    "golden shower",
    "goldenshower",
    "golliwog",
    "golliwogs",
    "god dammit",
    "god damn",
    "god damned",
    "god damned",
    "god damnit",
    "god damn mutha fucker",
    "gods damn",
    "gok kun",
    "golden shower",
    "golden shower",
    "golli wog",
    "golli wogs",
    "gonad",
    "gonads",
    "gonorrehea",
    "gonzagas",
    "goo girl",
    "gooch",
    "goodpoop",
    "good poop",
    "gook",
    "gook eye",
    "gook eyes",
    "gookeye",
    "Gook-eye",
    "gookeyes",
    "gookies",
    "gooks",
    "gooky",
    "gora",
    "goras",
    "goregasm",
    "Gorrel my spyt kak",
    "gotohell",
    "goy",
    "goyim",
    "Goyum",
    "gringo",
    "gringos",
    "groe",
    "groid",
    "groids",
    "grope",
    "grostulation",
    "group sex",
    "gspot",
    "g-spot",
    "gtfo",
    "gub",
    "gubba",
    "gubbas",
    "gubs",
    "guido",
    "guizi",
    "Guizi ",
    "gummer",
    "guro",
    "gwailo",
    "gwailos",
    "gweilo",
    "gweilos",
    "gyopo",
    "gyopos",
    "gyp",
    "gyped",
    "gypo",
    "gypos",
    "gypp",
    "gypped",
    "gyppie",
    "gyppies",
    "gyppo",
    "gyppos",
    "gyppy",
    "gyppys",
    "gypsies",
    "gypsy",
    "gypsys",
    "h*ng m*s*lf",
    "h0m0",
    "h0mo",
    "hadji",
    "hadjis",
    "haji",
    "hajis",
    "hajji",
    "hajjis",
    "half breed",
    "half caste",
    "Half-arsed",
    "halfbreed",
    "halfcaste",
    "ham flap   ",
    "hamas",
    "hand job",
    "handjob",
    "haole",
    "haoles",
    "hapa",
    "hard core",
    "hard core sex",
    "hard on",
    "hardcore",
    "hardcore sex",
    "hardcoresex",
    "hardon",
    "he11",
    "headfuck",
    "head fuck",
    "hebe",
    "hebephila",
    "hebephile",
    "hebephiles",
    "hebephilia",
    "hebephilic",
    "hebes",
    "heeb",
    "heebs",
    "heroin",
    "herp",
    "herpes",
    "herpy",
    "heshe",
    "he-she",
    "heterosexual",
    "hillbillies",
    "hillbilly",
    "hircismus",
    "hiscock",
    "hitler",
    "hitlerism",
    "hitlerist",
    "hiv",
    "ho",
    "hobag",
    "hodgie",
    "hoe",
    "Hoender naaiers",
    "hoender poes",
    "hoër",
    "hoer",
    "hoes",
    "hol bossel",
    "Hol naier",
    "holestuffer",
    "Holy Roller",
    "holy shit",
    "hom0",
    "homey",
    "homicide",
    "homo",
    "homobangers",
    "homoerotic",
    "homo bangers",
    "homo erotic",
    "homoey",
    "homosexual",
    "Hond Kerrie poes",
    "honger",
    "honkey",
    "honkeys",
    "honkie",
    "honkies",
    "honky",
    "hooch",
    "hook",
    "hookah",
    "hooker",
    "hookers",
    "hoor",
    "hootch",
    "hooter",
    "hooters",
    "hore",
    "hori",
    "horis",
    "hork",
    "horney",
    "horniest",
    "horny",
    "horseshit",
    "hosejob",
    "horse shit",
    "hose job",
    "hoser",
    "hot carl",
    "hot chick",
    "hot or not",
    "hot sex",
    "hotornot",
    "hotpussy",
    "hotsex",
    "hottotrot",
    "hot or not",
    "hot pussy",
    "hot sex",
    "hottotrot",
    "hot to trot",
    "how to kill",
    "how to murdep",
    "how to murder",
    "huge fat",
    "humped",
    "humping",
    "hun",
    "hussy",
    "Hy is 'n doos",
    "Hy is 'n duiwel",
    "hymen",
    "hymie",
    "hymies",
    "i w*nna d*e",
    "iap",
    "iberian slap",
    "iblowu",
    "ikeymo",
    "Ikey-mo",
    "Ikey-mo ",
    "ikeymos",
    "ikwe",
    "iky",
    "inbred",
    "incest",
    "indon",
    "indons",
    "injun",
    "injuns",
    "insest",
    "intercourse",
    "intheass",
    "in the ass",
    "j3rk0ff",
    "Jack Mormon ",
    "jack off",
    "jackass",
    "jackhole",
    "jackoff",
    "jack-off",
    "jackshit",
    "jack ass",
    "jack hole",
    "jack off",
    "jack-off",
    "jack shit",
    "jaggi",
    "jagoff",
    "jail bait",
    "jailbait",
    "Jakun",
    "jap",
    "japcrap",
    "japie",
    "japies",
    "japs",
    "jebus",
    "jerk off",
    "jerk0ff",
    "jerkass",
    "jerked",
    "jerkoff",
    "jerk-off",
    "jerries",
    "Jesus",
    "Jesus Christ",
    "Jesus H. Christ",
    "Jesus Harold Christ",
    "Jesus wept",
    "Jesus, Mary and Joseph",
    "jiga",
    "jigaboo",
    "jigaboos",
    "jigarooni",
    "jigaroonis",
    "jigg",
    "jigga",
    "jiggabo",
    "jiggaboo",
    "jiggabos",
    "jiggas",
    "jigger",
    "jiggerboo",
    "jiggers",
    "jiggs",
    "jigs",
    "jihad",
    "jijjiboo",
    "jijjiboos",
    "jimfish",
    "jism",
    "jiz",
    "jiz ",
    "jizim",
    "jizjuice",
    "jiz juice",
    "jizm",
    "jizm ",
    "jizz",
    "jizzed",
    "jizzim",
    "Jizzmond",
    "jizzum",
    "Jou bliksem",
    "Jou dom stuk kak",
    "Jou Foken Poes",
    "jou fokken goffel",
    "Jou fokken holnaaier poes",
    "Jou fokken poes kakker naipoes",
    "Jou Kafferkont",
    "Jou ma se bloed poes",
    "Jou ma se bloedpoes",
    "jou ma se chit stink",
    "Jou ma se Poes",
    "jou ma se skimil stink poes",
    "jou mase stink poes",
    "jou nare nai",
    "Jou nat naai",
    "jou ou naai",
    "jou pa se perd",
    "jou pa se stink vuil poes",
    "Jou Poeslike Kanker",
    "Jou saat sokkie",
    "Jou skeel teef",
    "jou sluimsloot bewonderaar",
    "Jou stink poes",
    "Jou suster se piel",
    "Jou teef",
    "Jou tollie",
    "jou vokken stuk geaborteerde fetus",
    "jou woers gemors",
    "juggalo",
    "juggs",
    "jungle bunnies",
    "jungle bunny",
    "junglebunny",
    "Jy gaan jou poes kak",
    "jy is n damduiker",
    "jy is n moeraspadda",
    "Jy is 'n poes",
    "jy jou nat naai",
    "Jy's 'n hondenaaier",
    "k*l* m*s*lf",
    "Kaafir",
    "kacap",
    "kacapas",
    "kacaps",
    "kafer",
    "kaffer",
    "kaffir",
    "Kaffir boetie",
    "kaffre",
    "kafir",
    "kak",
    "Kalar",
    "Kanaka",
    "kanake",
    "Kano",
    "katsap",
    "katsaps",
    "kawk",
    "Keling",
    "kettie kop",
    "Kharkhuwa",
    "khokhol",
    "khokhols",
    "khok hol",
    "khok hols",
    "kigger",
    "kike",
    "kikes",
    "kimchi",
    "kimchis",
    "kinbaku",
    "kink",
    "kinkster",
    "kinky",
    "kinky Jesus   ",
    "kkk",
    "klan",
    "klansman",
    "klansmen",
    "klanswoman",
    "klanswomen",
    "Knob jockey",
    "knob jocky",
    "knob jokey",
    "knobbing",
    "knobead",
    "knobed",
    "knobend",
    "knobhead",
    "knobjocky",
    "knobjokey",
    "knockers",
    "kock",
    "Kolorad",
    "Kompos Stamper",
    "kondum",
    "kondums",
    "kooch",
    "kooches",
    "koon",
    "kootch",
    "kotskop",
    "kraut",
    "krauts",
    "kuffar",
    "kum",
    "kumbubble",
    "kumbullbe",
    "kum bubble",
    "kum bullbe",
    "kummer",
    "kumming",
    "kumquat",
    "kums",
    "kunilingus",
    "kunja",
    "kunnilingus",
    "kunt",
    "kushi",
    "kushis",
    "kwa",
    "kwai ",
    "kwai lo",
    "kwai los",
    "kwif   ",
    "ky",
    "kyke",
    "kykes",
    "kyopo",
    "Kyopo ",
    "kyopos",
    "l3i+ch",
    "l3itch",
    "Labas",
    "labia",
    "lactate",
    "lameass",
    "Laowai",
    "Lap naai",
    "lapdance",
    "lardass",
    "Lek my bloed poes",
    "leper",
    "lesbain",
    "lesbayn",
    "lesbians",
    "lesbin",
    "lesbo",
    "lesbos",
    "lez",
    "lezbe",
    "lezbefriends",
    "lezbe friends",
    "lezbian",
    "lezbians",
    "lezbo",
    "lezbos",
    "lezz",
    "lezza",
    "lesbo",
    "lezzie",
    "lezzies",
    "lezzo",
    "lezzy",
    "licker",
    "lickme",
    "limey",
    "limpdick",
    "limp dick",
    "limy",
    "liquor",
    "livesex",
    "live sex",
    "lmfao",
    "loadedgun",
    "loaded gun",
    "lolita",
    "Looi n plooi",
    "LOOP KAK",
    "Loop naai",
    "lovebone",
    "lovegoo",
    "lovegun",
    "lovejuice",
    "lovemaking",
    "lovemuscle",
    "lovepistol",
    "loverocket",
    "love bone",
    "love goo",
    "love gun",
    "love juice",
    "love making",
    "love muscle",
    "love pistol",
    "love rocket",
    "lsd",
    "lube",
    "lubejob",
    "lube job",
    "lubra",
    "lucifer",
    "luckycammeltoe",
    "lucky cammeltoe",
    "lusty",
    "lynch",
    "m0f0",
    "m0fo",
    "m45terbate",
    "ma5terb8",
    "ma5terbate",
    "Mackerel Snapper ",
    "mafugly   ",
    "mahbuno",
    "mahbunos",
    "Majoos ",
    "make me come",
    "Mal Fok",
    "Mal vark",
    "male squirting",
    "mams",
    "ma-naaier",
    "mank genaaide bergbok",
    "manpaste",
    "man paste",
    "marijuana",
    "masapiel",
    "masochist",
    "massa",
    "mastabate",
    "mastabater",
    "masterb8",
    "masterbat*",
    "masterbat3",
    "masterbate",
    "master-bate",
    "masterbating",
    "masterbation",
    "masterbations",
    "masterblaster",
    "mastrabator",
    "masturbate",
    "masturbating",
    "masturbation",
    "mcfagget",
    "meatbeatter",
    "meat beatter",
    "meatrack",
    "menage a trois",
    "menses",
    "menstruate",
    "menstruation",
    "meth",
    "m-fucking",
    "mgger",
    "mggor",
    "mickeyfinn",
    "microphallus",
    "middle finger",
    "mideast",
    "milf",
    "minge",
    "minger",
    "missionary position",
    "mockey",
    "mockie",
    "mocky",
    "moerskont",
    "mof0",
    "Moffie",
    "mofo",
    "mo-fo",
    "moky",
    "money shot",
    "molest",
    "molestation",
    "molester",
    "molestor",
    "moneyshot",
    "mong",
    "moo moo foo foo",
    "moolie",
    "Moolinyan",
    "moon cricket",
    "moon crickets",
    "mooncricket",
    "mooncrickets",
    "moskal",
    "moskals",
    "moslem",
    "mosshead",
    "motha fuck",
    "motha fucka",
    "motha fuckas",
    "motha fuckaz",
    "motha fucked",
    "motha fucker",
    "motha fuckers",
    "motha fuckin",
    "motha fucking",
    "motha fuckings",
    "motha fucks",
    "mothafuck",
    "mothafucka",
    "mothafuckas",
    "mothafuckaz",
    "mothafucked",
    "mothafucked ",
    "mothafucker",
    "mothafuckers",
    "mothafuckin",
    "mothafucking",
    "mothafucking ",
    "mothafuckings",
    "mothafucks",
    "mother fuck",
    "mother fucked",
    "mother fucker",
    "mother fucker   ",
    "mother fuckers",
    "mother fuckin",
    "mother fucking",
    "mother fuckings",
    "mother fuckka",
    "mother fucks",
    "motherfuck",
    "motherfucka",
    "motherfucked",
    "motherfucker",
    "motherfuckers",
    "motherfuckin",
    "motherfucking",
    "motherfuckings",
    "motherfuckka",
    "motherfucks",
    "motherlovebone",
    "mother fuck",
    "mother fucka",
    "mother fucked",
    "mother fucker",
    "mother fuckers",
    "mother fuckin",
    "mother fucking",
    "mother fuckings",
    "mother fuckka",
    "mother fucks",
    "mother lovebone",
    "mr hands",
    "mtherfucker",
    "mthrfucker",
    "mthrfucking",
    "muff",
    "muff diver",
    "muff puff   ",
    "muffdive",
    "muffdiver",
    "muffdiving",
    "muffindiver",
    "mufflikcer",
    "muff dive",
    "muff diver",
    "muff diving",
    "muff indiver",
    "muff likcer",
    "mulatto",
    "muncher",
    "munging",
    "munt",
    "munter",
    "Mussie",
    "mutha",
    "mutha fecker",
    "mutha fuckker",
    "muthafecker",
    "muthafuckaz",
    "muthafucker",
    "muthafuckker",
    "mutha fecker",
    "mutha fuckaz",
    "mutha fucker",
    "mutha fuckker",
    "muther",
    "mutherfucker",
    "mutherfucking",
    "muthrfucking",
    "muther fucker",
    "muther fucking",
    "muthr fucking",
    "mzungu",
    "mzungus",
    "n1gga",
    "n1gger",
    "Naaiers",
    "nad",
    "nads",
    "nasty bitch",
    "nambla",
    "napalm",
    "nastybitch",
    "nastyho",
    "nastyslut",
    "nastywhore",
    "Nawar",
    "nawashi",
    "nazi",
    "nazism",
    "neche",
    "necro",
    "neechee",
    "need the dick   ",
    "neejee",
    "negres",
    "negress",
    "negro",
    "negroes",
    "negroid",
    "negros",
    "neonazi",
    "Nere ",
    "niagger",
    "nichi",
    "nichiwa",
    "nidge",
    "nig",
    "nig ",
    "nig nog",
    "Niga",
    "nigaboo",
    "nigar",
    "nigars",
    "niger",
    "nigers",
    "nigette",
    "nigettes",
    "nigg",
    "nigg3r",
    "nigg4h",
    "nigga",
    "niggah",
    "niggahs",
    "niggar",
    "niggaracci",
    "niggard",
    "niggarded",
    "niggarding",
    "niggardliness",
    "niggardlinesss",
    "niggard liness",
    "niggard linesss",
    "niggardly",
    "niggards",
    "niggars",
    "niggas",
    "niggaz",
    "nigger",
    "niggerhead",
    "niggerhole",
    "nigger head",
    "nigger hole",
    "niggers",
    "niggor",
    "niggres",
    "niggress",
    "niggresses",
    "nigguh",
    "nigguhs",
    "niggur",
    "niggurs",
    "niglet",
    "nignog",
    "nig-nog",
    "Nig nog ",
    "nigor",
    "nigors",
    "nigr",
    "nigra",
    "nigras",
    "nigre",
    "nigres",
    "nigress",
    "nigs",
    "nimphomania",
    "ninny hammer",
    "ninnyhammer",
    "nipple",
    "nipplering",
    "nipples",
    "nitchee",
    "Nitchie",
    "nitchy",
    "nittit",
    "nlgger",
    "nlggor",
    "nob",
    "nob head",
    "nob jocky",
    "nob jokey",
    "nobhead",
    "nobjocky",
    "nobjokey",
    "nofuckingway",
    "no fucking way",
    "nonce",
    "nook",
    "nookey",
    "nookie",
    "nooky",
    "noonan",
    "nooner",
    "Northern Monkey",
    "nsfw images",
    "nudger",
    "Nusayri",
    "nut butter   ",
    "nutfucker",
    "nut fucker",
    "nymph",
    "nympho",
    "nymphomania",
    "Om te kots",
    "Om vel te klap",
    "omorashi",
    "one cup two girls",
    "one guy one jar",
    "onosel fokken etter",
    "ontherag",
    "opiate",
    "opium",
    "oreos",
    "orga",
    "orgasim",
    "orgasims",
    "orgasm",
    "orgasmic",
    "orgasms",
    "orgies",
    "orgy",
    "osama",
    "Ou bloed poes",
    "Ou poes",
    "Oven Dodger",
    "Overner",
    "ovum",
    "ovums",
    "p*nch",
    "p*ssy",
    "p.u.s.s.y.",
    "p0rn",
    "paederasts",
    "paederasty",
    "paedophile",
    "Pak",
    "paki",
    "pakis",
    "Palagi",
    "Paleface",
    "pancake face",
    "pancake faces",
    "panooch",
    "panti",
    "pantie",
    "panties",
    "panty",
    "Papist ",
    "pastie",
    "payo",
    "pcp",
    "pearlnecklace",
    "peck",
    "peckerhead",
    "peckerwood",
    "pecker head",
    "pecker wood",
    "pederastic",
    "pederasts",
    "pederasty",
    "pedo",
    "pedobear",
    "pedophile",
    "pedophiles",
    "pedophilia",
    "pedophiliac",
    "pedophilic",
    "pee",
    "peehole",
    "peepee",
    "peepshow",
    "pee hole",
    "pee pee",
    "peep show",
    "peepshpw",
    "pegging",
    "pendy",
    "penetration",
    "peni5",
    "penial",
    "penile",
    "penis",
    "penis ",
    "penisbanger",
    "penis banger",
    "penises",
    "penisfucker",
    "penispuffer",
    "penis fucker",
    "penis puffer",
    "perv",
    "perversion",
    "peyote",
    "phalli",
    "phallic",
    "phone sex",
    "phonesex",
    "phuck",
    "phuk",
    "phuked",
    "phuking",
    "phukked",
    "phukking",
    "phuks",
    "phungky",
    "phuq",
    "pi55",
    "picaninny",
    "piccaninny",
    "pickaninnies",
    "pickaninny",
    "piece of shit",
    "piefke",
    "piefkes",
    "Piel",
    "piel kop",
    "Pielkop",
    "pigfucker",
    "piker",
    "pikey",
    "piky",
    "pillowbiter",
    "pimper",
    "pimpis",
    "pimpjuic",
    "pimpjuice",
    "pimpsimp",
    "pindick",
    "pimp juic",
    "pimp juice",
    "pimp simp",
    "pin dick",
    "pinko",
    "piss",
    "piss off",
    "piss pig",
    "pissed",
    "pissed off",
    "pisser",
    "pissers",
    "pisses",
    "pisses ",
    "pissflaps",
    "Pisshead",
    "piss flaps",
    "Piss head",
    "pissin",
    "pissin ",
    "pissing",
    "pissoff",
    "piss-off",
    "pissoff ",
    "pisspig",
    "Plastic Paddy",
    "pleasure chest",
    "pocha",
    "pochas",
    "pocho",
    "pochos",
    "pocketpool",
    "Poepol",
    "Poes",
    "Doos",
    "poes gesig",
    "poes you ma en pa doos",
    "Poesis",
    "Poeskak",
    "Poeslekker",
    "polack",
    "polacks",
    "Polaco",
    "Polak",
    "pole smoker",
    "polesmoker",
    "pollock",
    "pollocks",
    "pom",
    "ponyplay",
    "Poo",
    "poon",
    "poonani",
    "poonany",
    "poontang",
    "poop",
    "poop chute",
    "poopchute",
    "pooper",
    "pooperscooper",
    "pooping",
    "Poopuncher",
    "poorwhitetrash",
    "pooper scooper",
    "pooping",
    "Poo puncher",
    "poor white trash",
    "popimp",
    "porch monkey",
    "porch monkies",
    "porchmonkey",
    "porn",
    "pornflick",
    "pornking",
    "porno",
    "pornography",
    "pornos",
    "pornprincess",
    "Portagee",
    "prairie nigger",
    "prairie niggers",
    "Pribumi",
    "pric",
    "prickhead",
    "prickteaser",
    "prig",
    "prince albert piercing",
    "prod",
    "proddy dog ",
    "pron",
    "prostitute",
    "prude",
    "Pshek",
    "pthc",
    "pu55i",
    "pu55y",
    "pube",
    "pubes",
    "pubic",
    "pubiclice",
    "pubis",
    "pud",
    "pudboy",
    "pudd",
    "puddboy",
    "punani",
    "punanny",
    "punany",
    "punkass",
    "punky",
    "purina pricness",
    "puntang",
    "purinapricness",
    "puss",
    "pusse",
    "pussi",
    "pussie",
    "pussies",
    "pussy",
    "pussy fart   ",
    "pussy palace   ",
    "pussyeater",
    "pussyfucker",
    "pussylicker",
    "pussylicking",
    "pussylips",
    "pussylover",
    "pussypounder",
    "pussy eater",
    "pussy fucker",
    "pussy licker",
    "pussy licking",
    "pussy lips",
    "pussy lover",
    "pussy pounder",
    "pussys",
    "pust",
    "pusy",
    "puto",
    "quashie",
    "queaf",
    "queaf   ",
    "queef",
    "queerbait",
    "queerhole",
    "queero",
    "queers",
    "quim",
    "Quran thumper ",
    "ra8s",
    "raghead",
    "ragheads",
    "raging boner",
    "rape",
    "raped",
    "raper",
    "rapey",
    "raping",
    "rapist",
    "Rastus",
    "RateMe",
    "raunch",
    "Razakars",
    "rearentry",
    "rectal",
    "rectum",
    "rectus",
    "reefer",
    "reestie",
    "reetard",
    "reich",
    "renob",
    "rentafuck",
    "rere",
    "reverse cowgirl",
    "ribbed",
    "rimjaw",
    "rimjob",
    "rimming",
    "rioolboor",
    "Roske",
    "Rosuke",
    "rosy palm",
    "rosy palm and her 5 sisters",
    "Roto",
    "rumprammer",
    "ruski",
    "Russellite ",
    "russki",
    "russkie",
    "rusty trombone",
    "s hit",
    "s&m",
    "s*ic*de",
    "s.h.i.t.",
    "s.o.b.",
    "s_h_i_t",
    "s0b",
    "sadis",
    "sadism",
    "sadom",
    "sambos",
    "samckdaddy",
    "sand nigger",
    "sand niggers",
    "Sandler",
    "sandm",
    "sandnigger",
    "sanger",
    "santorum",
    "Sassenach",
    "sausage queen   ",
    "Sawney",
    "scag",
    "Scandihoovian",
    "scat",
    "schlong",
    "schvartse",
    "schvartsen",
    "schwartze",
    "schwartzen",
    "scissoring",
    "screwing",
    "screwyou",
    "screw you",
    "scroat",
    "scrog",
    "scrot",
    "scrote",
    "scrotum",
    "scrud",
    "scum",
    "seamen",
    "seks",
    "semen",
    "seppo",
    "seppos",
    "sex",
    "sexed",
    "sexfarm",
    "sexhound",
    "sexhouse",
    "sex farm",
    "sex hound",
    "sex house",
    "sexing",
    "sexkitten",
    "sex kitten",
    "sexo",
    "sexpot",
    "sexslave",
    "sextogo",
    "sextoy",
    "sextoys",
    "sex pot",
    "sex slave",
    "sex to go",
    "sex toy",
    "sex toys",
    "sexual",
    "sexually",
    "sexwhore",
    "sex whore",
    "sexy",
    "sexymoma",
    "sexyslim",
    "sexy moma",
    "sexy slim",
    "sh!+",
    "sh!t",
    "sh1t",
    "s-h-1-t",
    "shag",
    "shagger",
    "shaggin",
    "shagging",
    "shame dame",
    "shamedame",
    "shav",
    "shaved beaver",
    "shaved pussy",
    "shawtypimp",
    "shawty pimp",
    "sheeney",
    "Sheeny",
    "Sheep shagger",
    "Shegetz",
    "Shelta",
    "shhit",
    "shi+",
    "shibari",
    "Shiksa",
    "shinola",
    "Shiptar",
    "Shiptar",
    "shit",
    "s-h-i-t",
    "shit ass",
    "shit fucker   ",
    "shitass",
    "shitbag",
    "shitbagger",
    "shitblimp",
    "shitbrains",
    "shitbreath",
    "shitcan",
    "shitcanned",
    "shitcunt",
    "shitdick",
    "shit ass",
    "shit bag",
    "shit bagger",
    "shit blimp",
    "shit brains",
    "shit breath",
    "shit can",
    "shit canned",
    "shit cunt",
    "shit dick",
    "shite",
    "shiteater",
    "shit eater",
    "shited",
    "shitey",
    "shitface",
    "shitfaced",
    "shitfit",
    "shitforbrains",
    "shitfuck",
    "shitfucker",
    "shitfull",
    "shithapens",
    "shithappens",
    "shithead",
    "shitheads",
    "shithole",
    "shithouse",
    "shit face",
    "shit faced",
    "shit fit",
    "shit for brains",
    "shit fuck",
    "shit fucker",
    "shit full",
    "shit hapens",
    "shit happens",
    "shit head",
    "shit heads",
    "shit hole",
    "shit house",
    "shiting",
    "shitings",
    "shitlist",
    "shitola",
    "shitoutofluck",
    "shit out of luck",
    "shits",
    "shitspitter",
    "shitstain",
    "shit spitter",
    "shit stain",
    "shitt",
    "shitted",
    "shitter",
    "shitters",
    "shitters ",
    "shittier",
    "shittiest",
    "shitting",
    "shittings",
    "shitty",
    "shiz",
    "shiznit",
    "Shkije",
    "Shkutzim ",
    "shortfuck",
    "short fuck",
    "shota",
    "Shrek",
    "shrimping",
    "shylock",
    "shylocks",
    "Sideways vagina",
    "skag",
    "skank",
    "skankbitch",
    "skankfuck",
    "skankwhore",
    "skank bitch",
    "skank fuck",
    "skank whore",
    "skanky",
    "skankybitch",
    "skankywhore",
    "skanky bitch",
    "skanky whore",
    "skeet",
    "skinflute",
    "Skopianoi",
    "skullfuck",
    "skwa",
    "skwe",
    "slag",
    "slav",
    "sleaze",
    "sleazy",
    "Sleg etter",
    "slideitin",
    "slide it in",
    "slime",
    "slimeball",
    "slimebucket",
    "slopehead",
    "slopeheads",
    "slime ball",
    "slime bucket",
    "slopehead",
    "slope heads",
    "sloper",
    "slopers",
    "slopes",
    "slopey",
    "slopeys",
    "slopies",
    "slut",
    "slut bucket   ",
    "slutbag",
    "slutdumper",
    "slutkiss",
    "slut bag",
    "slut dumper",
    "slut kiss",
    "sluts",
    "slutt",
    "slutting",
    "slutty",
    "slutwear",
    "slutwhore",
    "slym sloot",
    "smackthemonkey",
    "slut wear",
    "slut whore",
    "slym sloot",
    "smack the monkey",
    "smegma",
    "smutty",
    "snatch",
    "snatchpatch",
    "snatch patch",
    "sniper",
    "snot",
    "snowback",
    "snowballing",
    "snownigger",
    "snow back",
    "snow balling",
    "snow nigger",
    "snuff",
    "sob",
    "s-o-b",
    "sod off",
    "sodom",
    "sodomise",
    "sodomite",
    "sodomize",
    "sodomy",
    "son of a bitch",
    "son of a motherless goat",
    "son of a whore",
    "sonofabitch",
    "son-of-a-bitch",
    "sonofbitch",
    "Soosmar-khor",
    "sooties",
    "sooty",
    "Soup-taker ",
    "souse",
    "soused",
    "Southern Faerie",
    "Southern Fairy",
    "Soutpiel",
    "spaghettibender",
    "spaghettinigger",
    "Sout piel",
    "spaghetti bender",
    "spaghetti nigger",
    "spaiker you self",
    "spankthemonkey",
    "spearchucker",
    "spearchuckers",
    "spank the monkey",
    "spear chucker",
    "spear chuckers",
    "sperm",
    "spermacide",
    "spermbag",
    "spermhearder",
    "spermherder",
    "sperm bag",
    "sperm hearder",
    "sperm herder",
    "spic",
    "spick",
    "spicks",
    "spics",
    "spig",
    "spigotty",
    "spik",
    "spiks",
    "splittail",
    "splooge",
    "splooge moose",
    "spooge",
    "spread legs",
    "spreadeagle",
    "spunk",
    "sqeh",
    "squa",
    "squarehead",
    "squareheads",
    "squaw",
    "squinty",
    "stagg",
    "steamy",
    "steek dit in jou fokken vet hol jou moer",
    "stfu",
    "stiffy",
    "Stink Gat",
    "stoned",
    "strap on",
    "strapon",
    "strappado",
    "stringer",
    "strip club",
    "stripclub",
    "stuinties",
    "stupidfuck",
    "stupidfucker",
    "stupid fuck",
    "stupid fucker",
    "style doggy",
    "suckass",
    "suckdick",
    "sucked",
    "sucking",
    "suckme",
    "suckmyass",
    "suckmydick",
    "suckmytit",
    "suckoff",
    "suck me",
    "suck my ass",
    "suck my dick",
    "suck my tit",
    "suck off",
    "suicide girls",
    "Suig my piel",
    "sultry women",
    "sumofabiatch",
    "sum of a biatch",
    "swamp guinea",
    "swamp guineas",
    "swastika",
    "sweet Jesus",
    "t1t",
    "t1tt1e5",
    "t1tties",
    "tacohead",
    "tacoheads",
    "taco head",
    "taco heads",
    "taff",
    "Taffy",
    "taig",
    "taking the piss",
    "tang",
    "tar babies",
    "tar baby",
    "tarbaby",
    "Tar-Baby ",
    "tard",
    "tart",
    "taste my",
    "tawdry",
    "tea bagging",
    "teabagging",
    "teat",
    "teets",
    "teez",
    "tenker",
    "terd",
    "teste",
    "testee",
    "testes",
    "testical",
    "testicle",
    "testicles",
    "testis",
    "Teuchter",
    "thirdleg",
    "threesome",
    "throating",
    "thrust",
    "thug",
    "thundercunt",
    "thunder cunt",
    "Tietkop",
    "tight white",
    "timber nigger",
    "timber niggers",
    "timbernigger",
    "tincker",
    "Ting tong",
    "tinkar",
    "tinkard",
    "Tinker",
    "tinkere",
    "tinkle",
    "tit",
    "tit wank   ",
    "titbitnipply",
    "titfuck",
    "titfucker",
    "titfuckin",
    "tit bit nipply",
    "tit fuck",
    "tit fucker",
    "tit fuckin",
    "titi",
    "tities",
    "titjob",
    "titlicker",
    "titlover",
    "tit licker",
    "tit lover",
    "tits",
    "titt",
    "tittie",
    "tittie5",
    "tittiefucker",
    "tittie fucker",
    "titties",
    "titty",
    "tittyfuck",
    "tittyfucker",
    "tittywank",
    "titwank",
    "titty fuck",
    "titty fucker",
    "titty wank",
    "tit wank",
    "toke",
    "tongethruster",
    "Tongue :O r :N",
    "tongue in a",
    "tongue thrust",
    "tongue tramp",
    "tonguethrust",
    "tonguetramp",
    "Tork-e khar",
    "tosser",
    "Tottie",
    "Touch of the tar brush",
    "towel head",
    "towel heads",
    "trailertrash",
    "trailertrash",
    "trannie",
    "tranny",
    "tribadism",
    "trots",
    "tub girl",
    "tubgirl",
    "tuckahoe",
    "tunneloflove",
    "tuck a hoe",
    "tunnel of love",
    "turd",
    "Turk",
    "turnon",
    "tushy",
    "tw4t",
    "twat",
    "twathead",
    "twatlips",
    "twat head",
    "twat lips",
    "twats",
    "twatty",
    "twatwaffle",
    "twink",
    "twinkie",
    "two fingers with tongue",
    "two girls one cup",
    "twobitwhore",
    "two bit whore",
    "twunt",
    "twunter",
    "tyncar",
    "tynekere",
    "tynkard",
    "tynker ",
    "tynkere",
    "uck",
    "unclefucker",
    "undies",
    "unfuckable",
    "upskirt",
    "uptheass",
    "upthebutt",
    "un fuckable",
    "up skirt",
    "up the ass",
    "up the butt",
    "urethra play",
    "urinate",
    "urophilia",
    "usama",
    "uterus",
    "uzi",
    "v14gra",
    "v1gra",
    "vag",
    "vagina",
    "vagina ",
    "vaginal",
    "vajayjay",
    "va-j-j",
    "valium",
    "Vatnik",
    "venus mound",
    "Vet fokker",
    "viagra",
    "vibrater",
    "vibrator",
    "violet wand",
    "virgin",
    "virginbreaker",
    "virgin breaker",
    "vjayjay",
    "voetsek",
    "Voetsek jou naai",
    "Vok jou",
    "vorarephilia",
    "vulva",
    "w00se",
    "wab",
    "wang",
    "wank",
    "wanker",
    "wanking",
    "wankjob",
    "wanky",
    "waysted",
    "wazoo",
    "wedgie",
    "weed",
    "weewee",
    "wet dream",
    "wetb",
    "wetback",
    "wh0re",
    "wh0reface",
    "whash",
    "whigger",
    "Whigger ",
    "whiggers",
    "whiskeydick",
    "whiskydick",
    "whiskey dick",
    "whisky dick",
    "whiz",
    "whoar",
    "whoralicious",
    "whore",
    "whorealicious",
    "whorebag",
    "whored",
    "whoreface",
    "whorefucker",
    "whorehopper",
    "whorehouse",
    "whore face",
    "whore fucker",
    "whore hopper",
    "whore house",
    "whores",
    "whoring",
    "wie de fok dink jy is jy",
    "wigga",
    "Wigga ",
    "wiggas",
    "wigger",
    "wiggers",
    "willie",
    "willies",
    "williewanker",
    "willy",
    "window licker",
    "wiseass",
    "wiseasses",
    "wn",
    "wog",
    "wogs",
    "woody",
    "wop",
    "wrapping men",
    "wrinkled starfish",
    "wtf",
    "wuss",
    "wuzzie",
    "Xiao Riben",
    "xkwe",
    "xtc",
    "xxx",
    "yaoi",
    "yarpie",
    "yarpies",
    "yeasty",
    "yellow showers",
    "yellowman",
    "yid",
    "yids",
    "yiffy",
    "yobbo",
    "you are a uncle fucker",
    "you ma se poes",
    "Your ma se poes",
    "Yuon",
    "zibbi",
    "zigabo",
    "zigabos",
    "zipperhead",
    "zipperheads",
    "zoophile",
    "zoophilia",
    "Zoroastrian",
    "zubb",
    "Cocaine",
    "Heroin ",
    "Opium",
    "Hashish",
    "Marijuana",
    "Amphetamine",
    "Methamphetamine",
    "MDMA ",
    "methylenedioxymethamphetamine",
    "LSD",
    "Rifles",
    "Rifles",
    "Gun",
    "Handgun",
    "Hand gun",
    "Sniper",
    "Sniper rifle",
    "Sniper rifles",
    "Machine gun",
    "Machine guns",
    "Semi automatic gun",
    "Semi-automatic firearm",
    "Semi-automatic gun",
    "Semi automatic firearm",
    "9 mil",
    "Nine mil",
    "firearms cartridge",
    "shotgun",
    "Grenade launcher",
    "Grenade",
    "Landmine",
    "assault rifle",
    "glock",
    "AK",
    "AK47",
    "AK47S",
    "AK–74",
    "AKM",
    "AKS",
    "MAK90",
    "MISR",
    "NHM90",
    "NHM91",
    "Rock River Arms",
    "LAR–47",
    "SA85",
    "SA93",
    "Vector Arms",
    "AK–47",
    "VEPR",
    "WASR–10,",
    "IZHMASH Saiga AK",
    "MAADI AK47",
    "Norinco 56S",
    "Norinco 56S2",
    "Norinco 84S",
    "Norinco 86S,",
    "AR–10",
    "AR–15",
    "Armalite M15 22LR Carbine",
    "Armalite M15–T",
    "Barrett REC7",
    "Beretta AR–70",
    "Beretta",
    "Bushmaster ACR",
    "Bushmaster Carbon 15",
    "Bushmaster MOE series",
    "Bushmaster XM15",
    "Colt Match Target Rifles",
    "DoubleStar AR rifles",
    "DPMS Tactical Rifles",
    "Heckler & Koch MR556",
    "Olympic Arms",
    "Remington R–15 rifle",
    "Rock River Arms LAR–15",
    "Sig Sauer SIG516 rifles",
    "Smith & Wesson",
    "M&P15",
    "Stag Arms",
    "Sturm",
    "Ruger & Co",
    "SR556 rifles",
    "Barrett M107A1",
    "Barrett M82A1",
    "Beretta CX4 Storm",
    "Barrett",
    "CETME Sporter",
    "Daewoo K–1",
    "Daewoo K–2",
    "Daewoo Max 1",
    "Daewoo Max 2",
    "Daewoo AR 100",
    "Daewoo AR 110C",
    "Fabrique Nationale",
    "FN Herstal FAL",
    "FN Herstal LAR",
    "FN Herstal 22 FNC",
    "FN Herstal 308 Match",
    "FN Herstal L1A1 Sporter",
    "FN Herstal PS90",
    "FN Herstal SCAR",
    "FN Herstal FS2000",
    "Feather Industries AT–9",
    "Galil Model AR",
    "Galil Model Model ARM",
    "Hi-Point Carbine HK–91",
    " Hi-Point Carbine HK–93",
    "Hi-Point Carbine HK–94",
    "Hi-Point Carbine HK–PSG–1",
    "Hi-Point Carbine HK USC",
    "Kel-Tec Sub–2000",
    "Kel-Tec SU–16",
    "Kel-Tec RFB",
    "Kel-Tec SIG AMT",
    "Kel-Tec SIG PE–57",
    "Sig Sauer SG 550",
    "Sig Sauer SG 551",
    "Springfield Armory SAR–48",
    "Steyr AUG",
    "Sturm",
    "Ruger Mini-14",
    "Tactical Rife M–14/20CF",
    "Thompson rifles",
    "Thompson M1SB",
    "Thompson T1100D",
    "Thompson T150D",
    "Thompson T1B",
    "Thompson T1B100D",
    "Thompson T1B50D",
    "Thompson T1BSB",
    "Thompson T1–C",
    "Thompson T1D",
    "Thompson T1SB",
    "Thompson T5",
    "Thompson T5100D",
    "Thompson TM1",
    "Thompson TM1C",
    "UMAREX UZI Rifle",
    "UZI Mini Carbine",
    "UZI Model A Carbine,",
    "UZI",
    "Valmet M62S",
    "Valmet M71S",
    "Valmet M78",
    "Weaver Arms Nighthawk",
    "Wilkinson Arms Linda Carbine",
    "",
    "Pistol",
    "Pistols:",
    "Centurion 39 AK pistol",
    "Draco AK–47 pistol",
    "HCR AK–47 pistol",
    "Hellpup AK–47 pistol",
    "Krinkov pistol",
    "Mini Draco AK–47 pistol",
    "Yugo Krebs Krink pistol",
    "AR–15 types",
    "spirit AR–15 pistol",
    "Bushmaster Carbon 15 pistol",
    "AR–15 pistol",
    "LAR 15 pistol",
    "Calico Liberty pistols",
    " DSA SA58 PKP FAL pistol",
    "Encom MP–9",
    "Encom MP–45",
    "Heckler & Koch",
    "",
    "SP-89 pistol",
    "Intratec AB–10",
    "TEC–22 Scorpion",
    "TEC–9",
    "TEC–DC9",
    "Kel-Tec PLR 16 pistol",
    "MAC–10",
    "MAC–11",
    "Masterpiece Arms",
    "MPA A930 Mini Pistol",
    "MPA460 Pistol",
    "MPA Tactical Pistol",
    "MPA Mini Tactical Pistol",
    "Military Armament Corp",
    "Ingram M–11",
    "Velocity Arms VMAC",
    "Sig Sauer P556 pistol",
    "Thompson TA510D",
    "Thompson TA5",
    "UZI machine gun",
    "Micro-UZI",
    "guns",
    "Shotguns",
    "Franchi LAW–12",
    "SPAS 12",
    "IZHMASH Saiga 12",
    "IZHMASH Saiga 12S",
    "IZHMASH Saiga 12S EXP–01",
    "IZHMASH Saiga 12K",
    "IZHMASH Saiga 12K–030",
    "IZHMASH Saiga 12K–040 Taktika",
    "Belt-fed semiautomatic firearms",
    "Firearm",
    "firearms",
    "NW M2HB",
    "handguns",
    "hand guns",
    "revolvers",
    "Semi-Auto Handguns",
    "Semi-Auto Handgun",
    "Beretta",
    "Bersa",
    "Bond Arms",
    "Browning",
    "Charter Arms",
    "Chiappa",
    "Christensen Arms",
    "Dan Wesson",
    "FMK",
    "FN",
    "FNH",
    "Glock",
    "Heckler + Koch",
    "Heizer",
    "Hi-Point",
    "HK ",
    "Honor Defense",
    "Iwi Usa",
    "Kahr",
    "Kahr Arms",
    "Kel-Tec",
    "Kimber",
    "Kriss",
    "Magnum Research",
    "NAA",
    "North American Arms",
    "Remington",
    "Ruger",
    "Sccy",
    "Sidewinder",
    "Sig Sauer",
    "Smith & Wesson",
    "Sphinx",
    "Springfield Armory",
    "SPS",
    "T/C Arms",
    "Tavor",
    "Taylors And Compan",
    "Walther",
    "Walther Arm"
  ];
  
  let _list = list;
  
  const matchPhrase = ({ phrase = "", local_list = []}) => {
    const finalList = _list.concat(local_list);
    const _reg = new RegExp(finalList.join("|"), "gi");
    const data = {
      matchedList: phrase.match(_reg).filter((item, i) => {
        return item !== "";
      }),
      match: phrase.match(_reg)
    };
  
    return data;
  };
  export default matchPhrase;
  


// WEBPACK FOOTER //
// ./src/words.js